import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-9 d-flex justify-content-center" }
const _hoisted_2 = {
  key: 0,
  class: "mb-9"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_5 = { class: "d-flex justify-content-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_8 = { key: 1 }

import { ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserService from "../../../users/services/UserService";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditAccountInfo',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit }) {

const isLoading = ref(false);
const modalForm = ref<InstanceType<typeof SimpleForm>>();
const accountDetail = ref(<any>[]);
const options = ref(null);
const label = ref("");
const vModel = ref(<any>null);
const comment = ref("");
const showCommentError = ref(false);
const updateType = ref("");

const updateSiteId = async () => {
  await UserService.updateAccountSiteID(accountDetail.value?.id, {
    id: accountDetail.value.id,
    site: vModel.value,
  });
  MsgPrompt.success("Update Site ID successfully").then(() => {
    modalForm.value?.hide();
  });
};

const updateAccountType = async () => {
  await UserService.updateAccountType(accountDetail.value?.id, {
    id: accountDetail.value.id,
    type: vModel.value,
  });
  MsgPrompt.success("Update Account Type successfully").then(() => {
    modalForm.value?.hide();
  });
};

const updatePlatformGroup = async () => {
  await UserService.updatePlatformGroup(
    accountDetail.value?.partyId,
    vModel.value
  );
  await UserService.rebuildUserIndex(accountDetail.value.value);
  MsgPrompt.success("Update Platform Group successfully").then(() => {
    modalForm.value?.hide();
  });
};

const updateFundType = async () => {
  await AccountService.updateFundType(accountDetail.value?.id, vModel.value);
  MsgPrompt.success("Update Fund Type successfully").then(() => {
    modalForm.value?.hide();
  });
};

const updateStatus = async () => {
  if (comment.value.trim() === "") {
    showCommentError.value = true;
    return;
  }
  showCommentError.value = false;
  await AccountService.updateAccountStatus(
    accountDetail.value?.id,
    vModel.value,
    {
      comment: comment.value,
    }
  );
  MsgPrompt.success("Update Status successfully").then(() => {
    modalForm.value?.hide();
  });
};

const updateLeverage = async () => {
  await AccountService.updateTradeAccountLeverage(
    accountDetail.value?.id,
    vModel.value
  );
  MsgPrompt.success("Update Leverage successfully").then(() => {
    modalForm.value?.hide();
  });
};

const updateData = async () => {
  isLoading.value = true;
  try {
    const updateFn = updateFunctions[updateType.value];
    await updateFn().then(() => {
      emit("refresh");
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
  isLoading.value = false;
};

const updateFunctions = {
  siteId: updateSiteId,
  accountType: updateAccountType,
  fundType: updateFundType,
  platformGroup: updatePlatformGroup,
  status: updateStatus,
  leverage: updateLeverage,
};

const show = (_accountDetail, _data) => {
  modalForm.value?.show();
  accountDetail.value = _accountDetail;
  options.value = _data?.options;
  label.value = _data?.label;
  vModel.value = _data?.vModel;
  updateType.value = _data?.type;
};


__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SimpleForm, {
      ref_key: "modalForm",
      ref: modalForm,
      title: label.value,
      "is-loading": isLoading.value,
      "disable-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_select, {
            modelValue: vModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vModel).value = $event)),
            class: "m-2 w-250px",
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item?.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        (updateType.value === 'status')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "d-flex justify-content-center",
                disabled: isLoading.value
              }, [
                _createVNode(_component_el_input, {
                  modelValue: comment.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comment).value = $event)),
                  class: "mb-2 w-250px",
                  placeholder: _ctx.$t('tip.enterReason'),
                  type: "textarea"
                }, null, 8, ["modelValue", "placeholder"])
              ], 8, _hoisted_3),
              (showCommentError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("error.fieldIsRequired")), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-light btn-success btn-md me-3",
            onClick: updateData
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
                  _hoisted_7
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("action.update")), 1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "is-loading"])
  ]))
}
}

})